import './dashboard.css'
import React from 'react'
import DashboardTable from '../dashboardtable/dashboardtable';
import data from './data1.json'
import { Chart } from "react-google-charts";

function Dashboard() {
    const dataG = [
        ["Year", "Sales"],
        ["20 May", 50],
        ["21 May", 100],
        ["22 May", 160],
        ["23 May", 60],
        ["24 May", 120],
        ["25 May", 150],
        ["26 May", 147],
    ];
    let tempCol = [columns[0], columns[1], columns[2], columns[3], columns[4], columns[5], columns[6], columns[7]]
    return (
        <>
            <div className='home-graph'>
                <div className='graph-cont'>
                    <div className='graph-head'>
                        <p>Load</p>
                        <select name="" id="">
                            <option value="none">Month</option>
                            <option value="Jan">Jan</option>
                            <option value="Feb">Feb</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="Aug">Aug</option>
                            <option value="Sep">Sep</option>
                            <option value="Oct">Oct</option>
                            <option value="Nov">Nov</option>
                            <option value="Dec">Dec</option>
                        </select>
                    </div>
                    <div className='graph'>
                        <Chart
                            chartType="AreaChart"
                            loader={<div>Loading Chart</div>}
                            width="100%"
                            height="100%"
                            data={dataG}
                            options={{
                                title: "Number of loads",
                                vAxis: { minValue: 0 },
                                chartArea: { width: '85%', height: '80%' },
                                colors: ["#FF7B00"],
                                legend: 'none',
                                hAxis: {},
                            }}
                        />
                    </div>
                </div>
                <div className='graph-sep'></div>
                <div className='graph-cont'>
                    <div className='graph-head'>
                        <p>Gross Income</p>
                        <select name="" id="">
                            <option value="none">Month</option>
                            <option value="Jan">Jan</option>
                            <option value="Feb">Feb</option>
                            <option value="March">March</option>
                            <option value="April">April</option>
                            <option value="May">May</option>
                            <option value="June">June</option>
                            <option value="July">July</option>
                            <option value="Aug">Aug</option>
                            <option value="Sep">Sep</option>
                            <option value="Oct">Oct</option>
                            <option value="Nov">Nov</option>
                            <option value="Dec">Dec</option>
                        </select>
                    </div>
                    <div className='graph'>
                        <Chart
                            chartType="AreaChart"
                            loader={<div>Loading Chart</div>}
                            width="100%"
                            height="100%"
                            data={dataG}
                            options={{
                                title: "Income Amount",
                                vAxis: { minValue: 0 },
                                chartArea: { width: '85%', height: '80%' },
                                colors: ["#16BA62"],
                                legend: 'none',
                                hAxis: {},
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className='dashboard-table-wrapper_'>
                <h3>Not Yet Delivered Loads</h3>
                <DashboardTable size={6} columns={tempCol} rows={data.data1} height={"363px"} />
            </div>
            <div style={{ padding: '13px 0' }}></div>
            <div className='dashboard-table-wrapper_'>
                <h3>Last Delivered Loads</h3>
                <DashboardTable size={6} columns={columns} rows={data.data2} height={"363px"} />
            </div>
            <div style={{ padding: '13px 0' }}></div>
        </>
    )
}

const columns = [
    { field: 'load_no', headerName: 'Load Number', minWidth: 60 },
    { field: 'driver', headerName: 'Driver', minWidth: 85 },
    { field: 'pickup', headerName: 'pickup', minWidth: 225 },
    { field: 'destination', headerName: 'Destination', minWidth: 225 },
    { field: 'pickup_date', headerName: 'Pickup Date', minWidth: 60 },
    { field: 'delivery_date', headerName: 'Delivery Date', minWidth: 60 },
    { field: 'rate', headerName: 'Rate', minWidth: 60 },
    {
        field: 'delivery_status', headerName: 'Delivery Status', minWidth: 60,
        renderCell: (params) => {
            const { delivery_status } = params.row
            const style = {
                padding: '3px 8px',
                fontSize: '11px',
                borderRadius: '5px',
                fontWeight: '500',
                background: delivery_status === 'Picked' ? 'rgba(255, 123, 0, 0.1)' : 'rgba(22, 186, 98, 0.1)',
                color: delivery_status === 'Picked' ? '#FF7B00' : '#16BA62'
            }
            return (
                <p style={style} >{delivery_status}</p >
            )
        }
    },
    {
        field: 'payment_status', headerName: 'Payment Status', minWidth: 60,
        renderCell: (params) => {
            const { payment_status } = params.row
            const style = {
                padding: '3px 8px',
                fontSize: '11px',
                borderRadius: '5px',
                fontWeight: '500',
                background: payment_status === 'Pending' ? 'rgba(254, 94, 79, 0.1)' : 'rgba(22, 186, 98, 0.1)',
                color: payment_status === 'Pending' ? '#FE5E4F' : '#16BA62'
            }
            return (
                <p style={style} >{payment_status}</p >
            )
        }
    },
];

export default Dashboard